var DynamicRequire = {
	require: function(fileName) {
		// Check if this was a required di
		var directory = _.find(_.keys(DynamicRequire.directories), function(dir) {
			return fileName.indexOf(dir) === 0;
		});

		if (directory) {
			var relativePath = fileName.replace(directory, ".");
			return DynamicRequire.directories[directory](relativePath);

		} else {
			throw "Could not dynamically require " + fileName;
		}
	},

	directories: {
		"action-icons": require.context("action-icons/", true, /.\.png*/),
		"patches": require.context("patches/", true, /.*\.png/),
		"misc": require.context("misc/", true, /.*\.png/),
		"perks": require.context("perks/", true, /.*\.png/),
		"furnitures": require.context("furnitures/", true, /.*\.png/),
		"official-icons": require.context("official-icons/", true, /.\.png*/),
		"onboarding": require.context("onboarding/", true, /.\.png*/),
		"owl-item-types": require.context("owl-item-types/", true, /.\.png*/),
		"quiz-icons": require.context("quiz-icons/", true, /.\.png*/),
		"skillset-banners": require.context("skillset-banners", true, /.\.png*/),
		"skillset-icons": require.context("skillset-icons/", true, /.\.png*/),
		"reading/reading-levels": require.context("reading/reading-levels/", true, /.\.png*/),		
		"ribbons/letters": require.context("ribbons/letters/", true, /.\.png*/),
		"ribbons/numbers": require.context("ribbons/numbers/", true, /.\.png*/),
		"ribbons/smilies": require.context("ribbons/smilies/", true, /.\.png*/),
		"owl_hoots": require.context("owl-hoots/", true, /.\.mp3*/),
		"background": require.context("background/", true, /.\.mp3*/),
		"dances": require.context("dances/", true, /.\.mp3*/),
		"speech-to-text": require.context("speech-to-text/", true, /.\.mp3*/),
		"tiers": require.context("tiers", true, /.\.png*/),
		"ranks": require.context("ranks", true, /.\.png*/),
		"features": require.context("features", true, /.\.gif*/),
		"logos": require.context("logos", true, /.\.jpg*|.\.png*/),
	}
}

module.exports = DynamicRequire;


// WEBPACK FOOTER //
// ./modules/lib/technical/DynamicRequire.js